export default "__VITE_ASSET__04811ff2__"